import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import { LanguageProvider } from "../context/LanguageContext";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Router from "./router";
import UpsellProvider from "../context/UpsellProvider";
import { ExamLockProvider } from "../context/ExamLockContext";
import AutoScrollToError from "../components/common/AutoScrollToError";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          {/* Above Router because both the exam session page (writer) and the sidebar inside
              MainLayout (reader) sit underneath it. */}
          <ExamLockProvider>
            <UpsellProvider>
              <Router />
            </UpsellProvider>
          </ExamLockProvider>

          <AutoScrollToError />
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover draggable theme="light" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
